<template>
    <div class="selectdiv"
         v-if="envLists.length>0&&$store.state.app.cloudConfigShow">
        <Dropdown placement="bottom-end"
                  :transfer="true"
                  trigger="click">
            <span class="rc-ellipsis">
                <i :class="envIcon(this.envLists[currindex].type)"></i>{{currText}}
                <i class="icon-arrow-under-o"></i>
            </span>
            <DropdownMenu slot="list">
                <div class="cloudDropdown">
                    <DropdownItem :class="currindex===i?'on':''"
                                  v-for="(item,i) in envLists"
                                  :name="item.name"
                                  :key="i">
                        <P @click="envClick(i)"
                           class="rc-ellipsis"
                           :title="item.name">
                            <i :class="envIcon(item.type)"></i>
                            <span class="env-name"
                                  :title="item.name">{{item.name}}
                            </span>
                        </P>
                    </DropdownItem>
                </div>
            </DropdownMenu>
        </Dropdown>
    </div>
</template>
<script>
import API from '@/service/api.js'
export default {
    name: 'env',
    data () {
        return {
            envLists: [],
            currText: null,
            currindex: null
        }
    },
    created () {
        this.getEnvs()
    },
    methods: {
        getEnvs () {
            // TODO 查询条件  云环境过滤
            this.envLists = []
            this.currText = null
            this.currindex = null
            this.axios.get(this.urlFormat(API.GET_ENVS, true)).then(res => {
                if (res && res.length) {
                    const data = []
                    res.forEach(item => {
                        data.push({
                            type: item.cloudEnvType,
                            value: item.id + '',
                            name: item.cloudEnvName
                        })
                    })
                    this.envLists = [{
                        id: null,
                        name: '全部'
                    }].concat(data)
                    const id = sessionStorage.getItem('resourcesEnvId')
                    if (id && id !== null) {
                        for (let i = 0; i < this.envLists.length; i++) {
                            if (this.envLists[i].value === id) {
                                this.currindex = i
                                this.currText = this.envLists[i].name
                            }
                        }
                    } else {
                        this.currindex = 0
                        this.currText = this.envLists[0].name
                    }
                }
            })
        },
        envClick (i) {
            this.currindex = i
            this.currText = this.envLists[i].name
            this.envLists[i].value ? sessionStorage.setItem('resourcesEnvId', this.envLists[i].value) : sessionStorage.removeItem('resourcesEnvId')
            this.$emit('envId', this.envLists[i].value)
        }
    }
}
</script>
<style lang="less" scoped>
.selectdiv {
    position: absolute;
    top: 7px;
    right: 15px;
    z-index: 11;
    color: #333;
    cursor: pointer;
    font-size: 12px;
    // width: 250px;
    .curr {
        height: 30px;
        line-height: 30px;
        display: inline-block;
        text-align: right;
        position: absolute;
        top: 0px;
        right: 0px;
        font-size: 12px;
    }
    i {
        display: inline-block;
        margin-left: 7px;
    }
    i.env-icon {
        margin: -1px 0 0 0;
    }

    li {
        padding: 0 5px;
        i {
            margin: 0;
        }
    }
}
.selectdiv:hover .selectul {
    display: block;
}
</style>
<style lang="less">
.ivu-dropdown-item {
    padding: 5px 16px;
}
</style>
